import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";
import { ModalPage } from "src/app/modals/modal/modal.page";
import { ModalComponent } from "src/app/modals/modal/modal.component";
import { AppHeaderService } from "../../header/app-header/app-header.service";
import { DatepickerModalPage } from "src/app/modals/datepicker-modal/datepicker-modal.page";
import { PeopleModalPage } from "src/app/modals/people-modal/people-modal.page";

export interface schedule {
  start: Date;
  end: Date;
  people: any;
}

@Component({
  selector: "app-SchedulePeopleModalPage-modal",
  templateUrl: "./schedulePeople-modal.page.html",
  styleUrls: ["./schedulePeople-modal.page.scss"],
})
export class SchedulePeopleModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  Lesson_GUID: string;
  schedulesList: any = [];
  loadingDone: boolean = false;
  searchText: string = "";

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global,
    private appHeaderService: AppHeaderService,
    public modalController: ModalController
  ) {}

  ngOnInit() {
    this.callingFilter = this.navParams.data.paramObject.callingFilter;
    this.User_GUID = this.navParams.data.paramObject.User_GUID;
    this.Vendor_GUID = this.navParams.data.paramObject.Vendor_GUID;
    this.Lesson_GUID = this.navParams.data.paramObject.Lesson_GUID;

    const formData: FormData = new FormData();
    formData.append("UserGUID", this.globals.XRSUser.GUID);
    formData.append("LessonGUID", this.Lesson_GUID);

    this.appservice
      .GetScheduledUserTraining(formData)
      .subscribe(async (result) => {
        try {
          let scheduledUserTraining = JSON.parse(result.toString());

          scheduledUserTraining.forEach(
            function (item) {
              const formDataU: FormData = new FormData();
              formDataU.append("UserGUID", this.globals.XRSUser.GUID);
              formDataU.append("LessonGUID", this.Lesson_GUID);
              formDataU.append("StartDateTime", item.StartDateTime);
              formDataU.append("EndDateTime", item.EndDateTime);

              this.appservice
                .GetScheduledLMSUsers(formDataU)
                .subscribe(async (result) => {
                  try {
                    let scheduledUsers = JSON.parse(result.toString());
                    let peopleSelected = [];

                    scheduledUsers.forEach((element) => {
                      element.GUID = element.UserGUID;

                      if (element.UserScheduled) {
                        peopleSelected.push(element);
                      }
                    });

                    var schedule = {
                      start: item.StartDateTime,
                      end: item.EndDateTime,
                      people: peopleSelected,
                    };

                    this.schedulesList.push(schedule);
                  } catch (e) {}
                });
            }.bind(this)
          );
        } catch (e) {}
      });

    this.loadingDone = true;
  }

  addSchedule(i) {
    var datetime = new Date();

    var GUID = this.appservice.GUID();
    var schedule = {
      start: null,
      end: null,
      people: [],
    };

    this.schedulesList.push(schedule);
  }

  removeSchedule(schedule) {
    const index = this.schedulesList.indexOf(schedule, 0);
    this.schedulesList.splice(index, 1);
  }

  async addPeople(i) {
    let peopleList = this.schedulesList[i].people;

    var paramObject = {
      callingFilter: "",
      User_GUID: "",
      multiSelect: true,
      peopleSelectedList: peopleList,
    };

    const modal = await this.modalController.create({
      component: PeopleModalPage,
      componentProps: {
        paramObject: paramObject,
      },
      cssClass: "modal-fullscreen",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null && dataReturned.data !== undefined) {
        let res = dataReturned.data;

        this.schedulesList[i].people = res;
      }
    });
    return await modal.present();
  }

  // async openDatepickerModal(event: any, date: any, key: string, i: any) {
  //   var paramObject = {
  //     date: date,
  //   };

  //   const modal = await this.modalController.create({
  //     component: DatepickerModalPage,
  //     componentProps: {
  //       paramObject: paramObject,
  //     },
  //     cssClass: "modal-datepicker",
  //   });

  //   modal.onDidDismiss().then((dataReturned) => {
  //     if (dataReturned !== null && dataReturned.data !== undefined) {
  //       this.schedulesList[i][key] = dataReturned.data._d.toISOString();
  //     }
  //   });
  //   return await modal.present();
  // }
  async openDatepickerModal(event: any, date: any, key: string, i: any) {
    const paramObject = {
      date: date ? new Date(date).toISOString() : new Date().toISOString(), // Ensure date is in ISO format
    };

    const modal = await this.modalController.create({
      component: DatepickerModalPage,
      componentProps: {
        paramObject: paramObject,
      },
      cssClass: "modal-datepicker",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned?.data) {
        // Check if dataReturned.data exists
        const selectedDate = dataReturned.data; // Use dataReturned.data directly
        this.schedulesList[i][key] = selectedDate; // Assign the ISO string directly
      }
    });

    return await modal.present();
  }

  async onSchedulePeopleSelect(event: any, schedulePeople: any) {
    await this.modalCtrl.dismiss(schedulePeople);
  }

  async onUploadContentClick(
    event: any,
    key: any,
    Content_GUID: any,
    modalHeading: any
  ) {
    var paramObject = {
      modalType: "Upload",
      modalBodyText: "",
      modalHeaderText: modalHeading,
      Content_GUID: Content_GUID,
    };

    const modal = await this.modalCtrl.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObject,
      },
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
      }
    });
    return await modal.present();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(null);
  }

  async onCloseUpload() {
    this.saveSchedules();

    await this.modalCtrl.dismiss(null);
  }

  saveSchedules() {
    var XRSUser = this.globals.XRSUser.GUID;
    var LessonGUID = this.Lesson_GUID;
    var appService = this.appservice;

    this.schedulesList.forEach(function (item) {
      const formData: FormData = new FormData();
      formData.append("GUID", XRSUser);
      formData.append("LessonGUID", LessonGUID);
      formData.append("UserList", JSON.stringify(item.people));
      formData.append("StartDateTime", item.start);
      formData.append("EndDateTime", item.end);
      formData.append("isAdding", "true");

      appService
        .AssignListOfLMSScheduledUsers(formData)
        .subscribe(async (result) => {
          try {
            let scheduledUserTraining = JSON.parse(result.toString());
          } catch (e) {}
        });
    });
  }

  // public onPagesLoaded(pagecount: PagesLoadedEvent): void {
  //   //this.TotalPages = pagecount.pagesCount;
  // }

  // public onPageRendered(pageRendered: PageRenderedEvent): void {
  //   //this.CurrentPage = pageRendered.pageNumber;
  // }
}
